export const categories = [
  { slug: 'movies-tv', name: '欧美影视', icon: 'ri-movie-2-line', description: '精选欧美电影、电视剧推荐与深度解读', color: 'primary' },
  { slug: 'music', name: '欧美音乐', icon: 'ri-music-2-line', description: '欧美流行、摇滚、电子等音乐精选', color: 'accent' },
  { slug: 'variety', name: '欧美综艺', icon: 'ri-tv-2-line', description: '热门欧美综艺节目与真人秀推荐', color: 'secondary' },
  { slug: 'documentary', name: '欧美纪录片', icon: 'ri-film-line', description: '高分欧美纪录片与人文纪实', color: 'primary' },
  { slug: 'fashion', name: '欧美时尚', icon: 'ri-shirt-line', description: '欧美时尚潮流趋势与品牌资讯', color: 'accent' },
  { slug: 'sports', name: '欧美体育', icon: 'ri-basketball-line', description: 'NBA、英超等欧美顶级体育赛事', color: 'secondary' },
];

export const articles = [
  {
    id: 1,
    slug: 'top-10-hollywood-movies-2024',
    title: '2024年度必看好莱坞大片TOP10：从史诗巨制到独立佳作',
    excerpt: '回顾2024年最值得关注的十部好莱坞电影，涵盖科幻、剧情、动作等多个类型，每一部都值得反复品味。',
    category: 'movies-tv',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20hollywood%20movie%20scene%20with%20dramatic%20lighting%20and%20film%20reel%20elements%2C%20dark%20cinema%20atmosphere%2C%20golden%20and%20warm%20tones%2C%20professional%20cinematography%20aesthetic%2C%20clean%20minimalist%20composition%20with%20soft%20bokeh%20background&width=800&height=450&seq=article-hollywood-01&orientation=landscape',
    date: '2024-12-15',
    readTime: '8分钟',
    views: 12800,
    tags: ['好莱坞', '电影推荐', '年度盘点'],
    content: `<p>2024年对于全球影迷来说是一个值得铭记的年份。好莱坞在这一年推出了众多令人惊艳的作品，既有宏大叙事的史诗巨制，也不乏充满人文关怀的独立佳作。</p>
    <p>在这一年中，我们见证了科幻电影的新高度、剧情片的深度挖掘以及动画电影的创新突破。以下是我们精心挑选的2024年度十大必看好莱坞电影。</p>
    <h3>1. 《星际迷航：新纪元》</h3>
    <p>作为经典科幻IP的全新篇章，《星际迷航：新纪元》以震撼的视觉效果和引人深思的故事主题赢得了观众的一致好评。导演以全新的视角诠释了人类探索未知的永恒主题。</p>
    <h3>2. 《沉默的证人》</h3>
    <p>这部法庭剧情片以精湛的表演和紧凑的叙事节奏征服了评论界。影片探讨了正义与真相之间的微妙关系，引发了广泛的社会讨论。</p>
    <h3>3. 《光影之城》</h3>
    <p>一部关于纽约艺术圈的独立电影，以独特的摄影风格和细腻的情感刻画打动了无数观众。影片中的每一帧画面都如同一幅精美的摄影作品。</p>`,
  },
  {
    id: 2,
    slug: 'european-art-film-guide',
    title: '欧洲艺术电影入门指南：从法国新浪潮到北欧冷峻美学',
    excerpt: '带你走进欧洲艺术电影的精彩世界，了解法国、意大利、德国等国的电影美学传统与当代创新。',
    category: 'movies-tv',
    imageUrl: 'https://readdy.ai/api/search-image?query=Vintage%20European%20cinema%20aesthetic%20with%20classic%20French%20film%20posters%20and%20warm%20ambient%20lighting%2C%20artistic%20black%20and%20white%20photography%20style%2C%20elegant%20cultural%20atmosphere%2C%20soft%20sepia%20tones%20with%20minimalist%20composition&width=800&height=450&seq=article-european-02&orientation=landscape',
    date: '2024-11-28',
    readTime: '12分钟',
    views: 9600,
    tags: ['欧洲电影', '艺术电影', '法国新浪潮'],
    content: `<p>欧洲艺术电影以其独特的审美追求和深刻的人文关怀，在世界电影史上占据着不可替代的地位。从法国新浪潮到意大利新现实主义，再到北欧的冷峻美学，欧洲电影人始终在探索影像表达的边界。</p>
    <h3>法国新浪潮：打破传统的革命</h3>
    <p>20世纪50年代末，以特吕弗、戈达尔为代表的法国导演掀起了一场电影语言革命。他们强调导演的"作者性"，用跳跃剪辑、手持摄影等手法打破了传统叙事规范。</p>
    <h3>意大利新现实主义：真实的力量</h3>
    <p>二战后的意大利电影人将镜头对准普通人的生活，用非职业演员和实景拍摄创造了一种前所未有的真实感。罗西里尼、德·西卡等导演的作品至今仍深深影响着世界电影。</p>
    <h3>北欧冷峻美学：极简中的深度</h3>
    <p>从伯格曼到拉斯·冯·提尔，北欧电影以冷峻的视觉风格和对人性深刻的探讨而著称。极简的画面构图、克制的表演风格，营造出一种独特的观影体验。</p>`,
  },
  {
    id: 3,
    slug: 'pop-music-trends-2024',
    title: '2024欧美流行音乐趋势：复古回潮与新声崛起',
    excerpt: '深入分析2024年欧美乐坛的最新动向，从复古Disco风潮到独立民谣复兴，把握当下最热的音乐脉搏。',
    category: 'music',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20concert%20stage%20with%20colorful%20dynamic%20lighting%20and%20silhouette%20of%20performer%2C%20vibrant%20music%20festival%20atmosphere%2C%20neon%20pink%20and%20warm%20amber%20stage%20lights%2C%20professional%20live%20music%20photography%20with%20soft%20fog%20effects&width=800&height=450&seq=article-music-03&orientation=landscape',
    date: '2024-11-20',
    readTime: '10分钟',
    views: 15200,
    tags: ['流行音乐', '音乐趋势', '欧美乐坛'],
    content: `<p>2024年的欧美流行音乐版图呈现出前所未有的丰富面貌。复古风潮与新声代的创造力交织碰撞，为乐迷带来了源源不断的惊喜。</p>
    <h3>Disco复兴：舞池永不停歇</h3>
    <p>从Dua Lipa到The Weeknd，越来越多的主流艺人将Disco元素融入当代流行音乐创作中。这种融合不仅唤起了人们对黄金年代的怀念，更赋予了经典风格全新的生命力。</p>
    <h3>独立民谣：安静的力量</h3>
    <p>在电子音乐和合成器主导的时代，一批独立民谣音乐人用最简单的吉他和真挚的歌词打动了无数听众。Phoebe Bridgers、Noah Kahan等艺术家的崛起标志着这一潮流的持续升温。</p>
    <h3>拉丁融合：跨越边界的节奏</h3>
    <p>拉丁音乐在全球范围内的持续火爆证明了音乐无国界。从Bad Bunny到Rosalía，拉丁艺术家们不断打破语言和文化的壁垒，创造出令人耳目一新的音乐作品。</p>`,
  },
  {
    id: 4,
    slug: 'classical-music-modern-life',
    title: '古典音乐在现代生活中的疗愈力量：从巴赫到极简主义',
    excerpt: '探索古典音乐如何在快节奏的现代生活中提供精神慰藉，推荐适合不同场景的古典音乐作品。',
    category: 'music',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20classical%20music%20concert%20hall%20with%20grand%20piano%20and%20soft%20warm%20lighting%2C%20orchestra%20silhouette%2C%20sophisticated%20cultural%20atmosphere%2C%20golden%20and%20cream%20tones%2C%20refined%20minimalist%20composition%20with%20shallow%20depth%20of%20field&width=800&height=450&seq=article-classical-04&orientation=landscape',
    date: '2024-11-10',
    readTime: '7分钟',
    views: 8400,
    tags: ['古典音乐', '音乐疗愈', '巴赫'],
    content: `<p>在这个信息爆炸的时代，古典音乐以其独特的深度和宁静，成为了许多人寻求内心平静的精神庇护所。研究表明，聆听古典音乐能够有效降低压力水平，提升专注力和创造力。</p>
    <h3>巴赫：秩序之美</h3>
    <p>巴赫的音乐以其精密的数学结构和深邃的情感表达而著称。《哥德堡变奏曲》和《大提琴组曲》等作品在当代仍被广泛用于冥想、学习和深度工作场景。</p>
    <h3>极简主义：当代的冥想</h3>
    <p>以Philip Glass、Steve Reich为代表的极简主义作曲家，用重复的音型和渐进的变奏创造了一种类似冥想状态的听觉体验。这种音乐风格与现代人的审美需求高度契合。</p>
    <h3>场景推荐</h3>
    <p>工作学习：巴赫《平均律钢琴曲集》；放松冥想：萨蒂《裸体舞曲》；睡前安眠：德彪西《月光》；创造力激发：斯特拉文斯基《春之祭》。</p>`,
  },
  {
    id: 5,
    slug: 'reality-show-evolution',
    title: '从《幸存者》到《鱿鱼游戏》真人版：欧美综艺进化史',
    excerpt: '追溯欧美综艺节目从传统竞赛到沉浸式体验的演变历程，解读当下最热门综艺背后的制作逻辑。',
    category: 'variety',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20reality%20TV%20show%20set%20with%20colorful%20neon%20lights%20and%20competition%20arena%20atmosphere%2C%20dynamic%20studio%20lighting%20design%2C%20vibrant%20orange%20and%20warm%20gold%20tones%2C%20professional%20broadcast%20production%20aesthetic%20with%20clean%20composition&width=800&height=450&seq=article-variety-05&orientation=landscape',
    date: '2024-11-05',
    readTime: '9分钟',
    views: 11300,
    tags: ['综艺节目', '真人秀', '欧美综艺'],
    content: `<p>欧美综艺节目经历了从简单竞赛到复杂叙事的华丽蜕变。如今的综艺不再是单纯的娱乐消遣，而是一种融合了戏剧冲突、社会实验和沉浸体验的复合型内容产品。</p>
    <h3>经典时代：规则驱动的竞赛</h3>
    <p>《幸存者》《极速前进》等经典节目定义了欧美综艺的早期范式——以明确的规则框架驱动选手竞争，观众通过支持特定选手获得参与感。</p>
    <h3>真人秀崛起：日常的戏剧化</h3>
    <p>《与卡戴珊同行》《真实主妇》系列将普通人的生活戏剧化，模糊了真实与表演的界限，开创了一种全新的综艺叙事模式。</p>
    <h3>沉浸式时代：体验为王</h3>
    <p>Netflix等流媒体平台的入局彻底改变了综艺节目的制作逻辑。《鱿鱼游戏》真人版的推出标志着综艺正在向电影化的沉浸体验进化。</p>`,
  },
  {
    id: 6,
    slug: 'bbc-documentary-masterpieces',
    title: 'BBC自然纪录片巅峰之作：每一帧都是壁纸的视觉盛宴',
    excerpt: '盘点BBC出品的十部经典自然纪录片，从《蓝色星球》到《地球脉动》，带你领略地球最震撼的生命奇迹。',
    category: 'documentary',
    imageUrl: 'https://readdy.ai/api/search-image?query=Breathtaking%20nature%20documentary%20scene%20with%20wildlife%20and%20dramatic%20landscape%2C%20cinematic%20aerial%20photography%2C%20golden%20sunset%20light%20over%20savanna%2C%20professional%20wildlife%20cinematography%20with%20rich%20warm%20earth%20tones%20and%20soft%20natural%20lighting&width=800&height=450&seq=article-bbc-06&orientation=landscape',
    date: '2024-10-28',
    readTime: '11分钟',
    views: 19600,
    tags: ['BBC', '自然纪录片', '蓝色星球'],
    content: `<p>BBC自然历史部门数十年来一直坚持用最先进的拍摄技术和最严谨的科学态度，为全球观众呈现地球最震撼的生命奇观。这些纪录片不仅是知识的源泉，更是视觉艺术的巅峰。</p>
    <h3>《蓝色星球》系列：深海奇迹</h3>
    <p>第一季就花费了四年时间、在全球200多个地点拍摄的《蓝色星球》，彻底改变了人类对海洋世界的认知。第二季更是运用了前所未有的深海拍摄技术。</p>
    <h3>《地球脉动》系列：生命的史诗</h3>
    <p>从极地到赤道，从高山到深海，《地球脉动》以惊人的画质和叙事呈现了地球上最具代表性的生态系统。第三季的4K HDR画面更是达到了纪录片的视觉巅峰。</p>
    <h3>《王朝》：家族的传奇</h3>
    <p>以动物家族为叙事核心的《王朝》，将纪录片的故事性提升到了新的高度。每一集都像一部精心编排的莎士比亚戏剧。</p>`,
  },
  {
    id: 7,
    slug: 'fashion-week-trends-2025',
    title: '2025春夏时装周趋势解读：极简主义的华丽回归',
    excerpt: '从纽约到巴黎，解析四大时装周透露的2025春夏流行趋势，极简设计、可持续时尚与大胆色彩三分天下。',
    category: 'fashion',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20fashion%20runway%20show%20with%20models%20in%20minimalist%20designer%20clothing%2C%20soft%20spotlight%20and%20dramatic%20stage%20lighting%2C%20warm%20neutral%20tones%20with%20cream%20and%20beige%20palette%2C%20high%20fashion%20editorial%20photography%20with%20clean%20composition&width=800&height=450&seq=article-fashion-07&orientation=landscape',
    date: '2024-10-20',
    readTime: '10分钟',
    views: 13500,
    tags: ['时装周', '时尚趋势', '极简主义'],
    content: `<p>2025春夏时装周落下帷幕，从纽约到巴黎，全球顶级设计师们为时尚界呈现了一场关于未来美学的深刻思考。本季最大的主题是"回归本质"——极简主义以全新的姿态强势回归。</p>
    <h3>极简主义的当代诠释</h3>
    <p>不同于90年代的冷淡极简，2025春夏的极简主义更加温暖和人性化。The Row、Jil Sander等品牌用柔软的材质和流畅的线条，重新定义了"少即是多"的美学理念。</p>
    <h3>可持续时尚：不再只是口号</h3>
    <p>越来越多的品牌将可持续理念贯穿于设计和生产的全过程。Stella McCartney继续领跑环保时尚，而新兴品牌也在材料创新方面取得了突破性进展。</p>
    <h3>大胆色彩：点亮中性基调</h3>
    <p>在以中性色为主调的大环境下，大胆的亮色作为点缀频繁出现在各大秀场上。Bottega Veneta的亮橙、Loewe的草绿，为极简底色注入了鲜活能量。</p>`,
  },
  {
    id: 8,
    slug: 'nba-2024-season-preview',
    title: 'NBA 2024-25赛季前瞻：新格局下的冠军之争',
    excerpt: '深度分析NBA新赛季各队实力变化，从超级球队到黑马之选，全面预测新赛季的争冠格局。',
    category: 'sports',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dynamic%20basketball%20game%20action%20scene%20with%20player%20dunking%20under%20arena%20lights%2C%20dramatic%20sports%20photography%2C%20warm%20amber%20and%20orange%20court%20lighting%2C%20professional%20NBA%20game%20atmosphere%20with%20motion%20blur%20effect%20and%20clean%20composition&width=800&height=450&seq=article-nba-08&orientation=landscape',
    date: '2024-10-15',
    readTime: '12分钟',
    views: 22100,
    tags: ['NBA', '篮球', '赛季前瞻'],
    content: `<p>NBA 2024-25赛季即将拉开帷幕，经历了一个充满变数的休赛期后，联盟格局发生了显著变化。新的劳资协议和交易规则正在重塑各队的建队思路。</p>
    <h3>东部：三足鼎立</h3>
    <p>凯尔特人作为卫冕冠军保持了核心阵容的完整，雄鹿在字母哥的带领下依旧强势，而76人的新阵容组合也令人充满期待。东部的竞争将异常激烈。</p>
    <h3>西部：群雄逐鹿</h3>
    <p>掘金、雷霆、森林狼等年轻球队的崛起让西部的竞争格局更加扑朔迷离。独行侠和太阳的超级组合能否在新赛季兑现天赋值得关注。</p>
    <h3>新星观察</h3>
    <p>文班亚马的二年级赛季备受瞩目，这位天赋异禀的法国天才将如何进化是新赛季最大的看点之一。此外，2024届新秀中也有多位值得关注的面孔。</p>`,
  },
  {
    id: 9,
    slug: 'epl-mid-season-review',
    title: '英超赛季半程回顾：传统豪门与新兴势力的碰撞',
    excerpt: '盘点英超赛季上半程的精彩瞬间，分析各支球队的战术演变和关键球员表现，预测下半程的走势。',
    category: 'sports',
    imageUrl: 'https://readdy.ai/api/search-image?query=Intense%20soccer%20match%20moment%20with%20players%20competing%20on%20green%20pitch%20under%20stadium%20lights%2C%20dramatic%20sports%20action%20photography%2C%20warm%20evening%20stadium%20atmosphere%2C%20professional%20football%20cinematography%20with%20rich%20green%20and%20gold%20tones&width=800&height=450&seq=article-epl-09&orientation=landscape',
    date: '2024-10-08',
    readTime: '11分钟',
    views: 18700,
    tags: ['英超', '足球', '赛季回顾'],
    content: `<p>英超联赛作为全球最具观赏性的足球联赛，2024-25赛季的上半程再次证明了这一点。从战术革新到新星涌现，这半个赛季充满了无数精彩故事。</p>
    <h3>冠军争夺：三强争霸</h3>
    <p>曼城、阿森纳和利物浦三支球队在上半程展现出了冠军级别的竞技水平。曼城在瓜迪奥拉的体系下依旧行云流水，阿森纳的年轻阵容日趋成熟，利物浦则在攻防两端都展现出了极高的效率。</p>
    <h3>黑马崛起</h3>
    <p>阿斯顿维拉、布莱顿等球队的出色表现打破了传统的Big 6格局。这些球队通过出色的战术体系和球员发展策略，正在逐渐缩小与传统豪门之间的差距。</p>
    <h3>球员焦点</h3>
    <p>哈兰德继续以惊人的进球效率领跑射手榜，萨卡则用全面的表现证明了他是当今最出色的边锋之一。新援们的表现同样值得关注。</p>`,
  },
  {
    id: 10,
    slug: 'fashion-icons-documentary',
    title: '时尚传奇：十部必看的欧美时尚纪录片推荐',
    excerpt: '从Dior到McQueen，盘点十部深入时尚产业内核的经典纪录片，了解设计大师背后的故事与时代印记。',
    category: 'documentary',
    imageUrl: 'https://readdy.ai/api/search-image?query=Fashion%20designer%20studio%20with%20elegant%20dress%20forms%20and%20fabric%20swatches%2C%20soft%20natural%20light%20streaming%20through%20windows%2C%20luxurious%20creative%20workspace%20atmosphere%2C%20warm%20cream%20and%20gold%20tones%2C%20refined%20editorial%20photography%20with%20clean%20minimalist%20composition&width=800&height=450&seq=article-fashiondoc-10&orientation=landscape',
    date: '2024-09-25',
    readTime: '8分钟',
    views: 10200,
    tags: ['时尚', '纪录片', '设计师'],
    content: `<p>时尚不仅是衣物的艺术，更是一个时代的文化缩影。以下十部纪录片将带你走进时尚产业的幕后，了解那些定义了时代审美的设计大师和他们背后的故事。</p>
    <h3>《Dior and I》：高定的灵魂</h3>
    <p>这部纪录片记录了Raf Simons接手Dior后的首个高级定制系列创作过程。影片展现了高定工坊中工匠们的精湛技艺和设计师面临的压力与挑战。</p>
    <h3>《McQueen》：天才与挣扎</h3>
    <p>Alexander McQueen是时尚界最具颠覆性的设计师之一。这部纪录片不仅展现了他惊人的创造力，也揭示了他在名利与自我之间的内心挣扎。</p>
    <h3>《The September Issue》：时尚圣经的诞生</h3>
    <p>以Vogue美国版九月刊的制作过程为主线，这部纪录片揭开了时尚杂志运作的神秘面纱，也呈现了Anna Wintour与Grace Coddington之间微妙的合作关系。</p>`,
  },
  {
    id: 11,
    slug: 'oscar-predictions-2025',
    title: '2025奥斯卡前瞻：谁是下一个最佳影片的有力竞争者',
    excerpt: '随着颁奖季临近，我们为您梳理最有希望角逐2025年奥斯卡最佳影片的十部种子选手及其背后的故事。',
    category: 'movies-tv',
    imageUrl: 'https://readdy.ai/api/search-image?query=Luxurious%20Oscar%20awards%20ceremony%20scene%20with%20golden%20statue%20and%20red%20carpet%2C%20elegant%20Hollywood%20glamour%20atmosphere%2C%20warm%20golden%20spotlight%20and%20sophisticated%20cinema%20aesthetic%2C%20premium%20event%20photography%20with%20rich%20warm%20tones&width=800&height=450&seq=article-oscar-11&orientation=landscape',
    date: '2024-09-18',
    readTime: '9分钟',
    views: 16800,
    tags: ['奥斯卡', '电影奖项', '好莱坞'],
    content: `<p>随着秋季电影节的陆续举行，2025年奥斯卡颁奖季的轮廓逐渐清晰。从威尼斯到多伦多，多部影片已经获得了评论界的高度认可，成为最佳影片的有力竞争者。</p>
    <h3>种子选手分析</h3>
    <p>今年的竞争格局异常激烈。既有知名导演的新作，也有新锐力量的惊艳亮相。历史传记、社会议题、艺术探索等多元题材让本届奥斯卡充满了看点。</p>
    <h3>技术类奖项前瞻</h3>
    <p>在最佳摄影、最佳视觉效果等技术类奖项方面，几部科幻和奇幻类作品展现出了极高的制作水准，有望在技术类奖项中有所斩获。</p>`,
  },
  {
    id: 12,
    slug: 'rock-music-legends',
    title: '摇滚不死：欧美摇滚乐史上最具影响力的十大乐队',
    excerpt: '从披头士到皇后乐队，重温那些改变了音乐史的欧美摇滚传奇，感受摇滚精神的永恒魅力。',
    category: 'music',
    imageUrl: 'https://readdy.ai/api/search-image?query=Classic%20rock%20band%20performing%20on%20stage%20with%20electric%20guitars%20and%20dramatic%20backlighting%2C%20vintage%20concert%20photography%20style%2C%20warm%20amber%20stage%20lights%20with%20smoke%20effects%2C%20nostalgic%20music%20atmosphere%20with%20rich%20contrast%20and%20grainy%20texture&width=800&height=450&seq=article-rock-12&orientation=landscape',
    date: '2024-09-10',
    readTime: '13分钟',
    views: 14500,
    tags: ['摇滚乐', '乐队', '音乐史'],
    content: `<p>摇滚乐不仅是一种音乐形式，更是二十世纪最具影响力的文化运动之一。从50年代的萌芽到如今的多元发展，摇滚乐始终以其独特的能量和反叛精神打动着每一代人。</p>
    <h3>The Beatles：改变一切的乐队</h3>
    <p>披头士不仅改变了流行音乐的面貌，更深刻地影响了整个西方文化。从《Love Me Do》到《Abbey Road》，他们的音乐进化史就是一部现代流行音乐的发展史。</p>
    <h3>Led Zeppelin：重摇滚的先驱</h3>
    <p>齐柏林飞艇以极具爆发力的吉他演奏和宏大的音乐结构开创了硬摇滚和重金属的先河。《Stairway to Heaven》至今仍被视为摇滚史上最伟大的作品之一。</p>
    <h3>Queen：舞台之王</h3>
    <p>皇后乐队以其华丽的舞台表现和跨越多种音乐风格的创作能力成为了摇滚乐坛独一无二的存在。Freddie Mercury的传奇至今仍在激励着无数音乐人。</p>`,
  },
];

export const faqItems = [
  {
    question: '欧美一区是什么？',
    answer: '欧美一区是一个专注于欧美影视、音乐与文化内容的精选导航平台。我们汇聚海量优质欧美资源，为您提供最新、最全面的欧美一区影视导航、音乐推荐和文化资讯服务，让您轻松畅享欧美一区带来的高清视听体验与多元文化魅力。',
  },
  {
    question: '欧美一区的资源是否高清？',
    answer: '是的，欧美一区致力于为用户提供高品质的视听内容。我们推荐的欧美一区高清资源均经过精心筛选，确保画质清晰、音效出色，让您享受影院级的观看体验。同时，我们持续更新资源库，保证内容的时效性和多样性。',
  },
  {
    question: '如何在欧美一区找到感兴趣的内容？',
    answer: '您可以通过欧美一区的分类导航系统快速找到感兴趣的内容。我们设有影视、音乐、综艺、纪录片、时尚、体育等多个分类频道，每个分类下都有详细的内容标签和推荐列表。此外，首页的热门榜单和精选推荐也能帮助您发现优质内容。',
  },
  {
    question: '欧美一区的内容更新频率如何？',
    answer: '欧美一区保持每日更新的节奏，我们的编辑团队持续追踪欧美影视、音乐和文化领域的最新动态，确保您能在第一时间获取新鲜内容。热门资源、影视新片、音乐专辑等信息都会在更新后迅速呈现。',
  },
  {
    question: '欧美一区是否支持在线观看？',
    answer: '欧美一区作为内容导航和推荐平台，为您提供全面的资源导航服务。通过我们的平台，您可以快速定位感兴趣的内容，并通过我们提供的导航链接访问相关资源。我们持续优化推荐算法，让欧美一区在线观看体验更加流畅便捷。',
  },
];

export const testimonials = [
  {
    name: '张先生',
    role: '资深影迷',
    content: '欧美一区是我每天必看的网站！作为一个电影爱好者，这里的影评和推荐帮我发掘了很多优秀的欧美电影。分类清晰，内容专业，强烈推荐给所有影迷朋友！',
    rating: 5,
  },
  {
    name: '王女士',
    role: '音乐媒体人',
    content: '欧美一区的音乐板块做得非常出色，从流行到古典、从独立到摇滚，覆盖面广且分析深入。作为从业者，我非常欣赏编辑团队的专业水准。',
    rating: 5,
  },
  {
    name: '李先生',
    role: '留学生',
    content: '在国外留学时开始关注欧美一区，它帮我更好地了解欧美流行文化。网站设计简洁大方，内容更新及时，是我获取欧美资讯的首选平台。',
    rating: 5,
  },
  {
    name: '赵女士',
    role: '时尚博主',
    content: '欧美一区的时尚板块内容质量很高，时装周报道、设计师专访都很及时。对于关注欧美时尚趋势的朋友来说，这是一个不可多得的优质内容平台。',
    rating: 4,
  },
  {
    name: '陈先生',
    role: '体育评论员',
    content: '体育板块的赛事分析和行业洞察非常专业。NBA和英超的深度解读让我受益匪浅，推荐的内容既有深度又通俗易懂，适合各类读者。',
    rating: 5,
  },
  {
    name: '刘女士',
    role: '文化爱好者',
    content: '欧美一区不仅有娱乐内容，还有丰富的文化深度文章。纪录片的推荐和解读尤其精彩，让我对欧美文化有了更深入的了解。真心推荐给大家！',
    rating: 5,
  },
];

export const platformStats = [
  { label: '精选内容', value: '50,000+' },
  { label: '分类频道', value: '6' },
  { label: '月活跃用户', value: '200万+' },
  { label: '内容好评率', value: '98%' },
];

export const contactInfo = {
  email: 'contact@oumei1.com',
  phone: '+86 400-123-4567',
  address: '北京市朝阳区建国路88号SOHO现代城A座',
  wechat: 'oumei1_official',
  weibo: '@欧美一区官方',
};